import { QueryClient, useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { GET_EVENT_TAGS, TAGS_API_URL } from '@/constants';
import { apiUrl } from '@/helpers';
import { CreateTagPayload, ErrorResponse, Options, UpdateTagPayload } from '@/types';

export const tagsEndpoints = {
  getEventTags: (eventId: string) =>
    axios.get(
      `${apiUrl()}${TAGS_API_URL}/${eventId}`
    ),
  createTag: (payload: CreateTagPayload) => axios.post(`${apiUrl()}${TAGS_API_URL}`, payload),
  updateTag: (payload: UpdateTagPayload) => axios.put(`${apiUrl()}${TAGS_API_URL}`, payload),
};

export const useGetEventTags = (eventId: string) => {
  return useQuery(
    [GET_EVENT_TAGS, { eventId }],
    () => tagsEndpoints.getEventTags(eventId), {
      enabled: !!eventId
    }
  );
};

export const useCreateTagMutation = (queryClient: QueryClient, options: Options) => {
  return useMutation(tagsEndpoints.createTag, {
    onSuccess: (response) => {
      options.onSuccess(response);
      queryClient.invalidateQueries([GET_EVENT_TAGS]);
    },
    onError: (error) => {
      options.onError(error as ErrorResponse);
    }
  });
};

export const useUpdateTagMutation = (queryClient: QueryClient, options: Options) => {
  return useMutation(tagsEndpoints.updateTag, {
    onSuccess: (response) => {
      options.onSuccess(response);
      queryClient.invalidateQueries([GET_EVENT_TAGS]);
    },
    onError: (error) => {
      options.onError(error as ErrorResponse);
    }
  });
};
